module.exports = __webpack_public_path__ + "image/header_img1.jpg";